import React, { createContext, useContext, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

const TokenContext = createContext();

export const TokenProvider = ({ children }) => {
    const [tokenData, setTokenData] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const baseUrl = process.env.REACT_APP_API_URL;
    const accessToken = localStorage.getItem('access_token');
    const userType = localStorage.getItem('user_type');
    const endpoint = userType === 'administrador' ? '/manager/usuario/' : '/participante/usuario/';
    const [solicitarPremio, setSolicitarPremio] = useState('');
    const [solicitarVenda, setSolicitarVenda] = useState('');

    const checkToken = async () => {
        try {
            const response = await fetch(`${baseUrl}${endpoint}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`,
                },
            });

            if (response.ok) {
                const data = await response.json();
                setTokenData(data);
                // console.log(data)
                setIsAuthenticated(true);
            } else {
                localStorage.removeItem('access_token');
                localStorage.removeItem('user_type');
                localStorage.removeItem('user_id');
                setIsAuthenticated(false);
            }
        } catch (error) {
            setIsAuthenticated(false);
        }
    };

    useEffect(() => {
        if (accessToken) {
            checkToken();
        } else {
            setIsAuthenticated(false);
        }
    }, [accessToken]);

    useEffect(() => {
        const today = new Date();
        const yearVenda = 2026;

        const startDateVenda = new Date(yearVenda, 2, 1, 0, 0, 0);      // 01/03/2026 00:00:00
        const endDateVenda   = new Date(yearVenda, 11, 31, 23, 59, 59); // 31/12/2026 23:59:59

        const yearPremio = 2027;

        const startDatePremio = new Date(yearPremio, 0, 1, 0, 0, 0);     // 01/01/2027 00:00:00
        const endDatePremio   = new Date(yearPremio, 0, 15, 23, 59, 59); // 15/01/2027 23:59:59

        setSolicitarPremio(today >= startDatePremio && today <= endDatePremio);
        setSolicitarVenda(today >= startDateVenda && today <= endDateVenda);
    }, []);

    const logOutUser = async () => {
        try {
            const response = await fetch(`${baseUrl}${endpoint}logout`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`,
                },
            });

            if (response.ok) {
                localStorage.removeItem('access_token');
                localStorage.removeItem('user_type');
                localStorage.removeItem('user_id');
                setIsAuthenticated(false);
                <Navigate to='/' replace />;
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    return (
        <TokenContext.Provider value={{ tokenData, isAuthenticated, checkToken, logOutUser, setIsAuthenticated, solicitarPremio, solicitarVenda }}>
            {children}
        </TokenContext.Provider>
    );
};

export const useToken = () => useContext(TokenContext);
